import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getDefaultPageSize as te } from "../../pagination/src/utils.js";
import { useSorter as ne } from "./use-sorter.js";
import { createShallowClonedObject as N } from "./utils.js";
import { createTreeMate as ie } from "../../../../../../treemate@0.3.11/node_modules/treemate/es/create.js";
import k from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import j from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import { call as o } from "../../_utils/vue/call.js";
import { warn as ae } from "../../_utils/naive/warn.js";
import { computed as l } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as v } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function Pe(a, {
  dataRelatedColsRef: m
}) {
  const F = l(() => {
    const e = (t) => {
      for (let i = 0; i < t.length; ++i) {
        const n = t[i];
        if ("children" in n)
          return e(n.children);
        if (n.type === "selection")
          return n;
      }
      return null;
    };
    return e(a.columns);
  }), P = l(() => {
    const {
      childrenKey: e
    } = a;
    return ie(a.data, {
      ignoreEmptyChildren: !0,
      getKey: a.rowKey,
      getChildren: (t) => t[e],
      getDisabled: (t) => {
        var i, n;
        return !!(!((n = (i = F.value) === null || i === void 0 ? void 0 : i.disabled) === null || n === void 0) && n.call(i, t));
      }
    });
  }), K = k(() => {
    const {
      columns: e
    } = a, {
      length: t
    } = e;
    let i = null;
    for (let n = 0; n < t; ++n) {
      const r = e[n];
      if (!r.type && i === null && (i = n), "tree" in r && r.tree)
        return n;
    }
    return i || 0;
  }), u = v({}), {
    pagination: h
  } = a, O = v(h && h.defaultPage || 1), z = v(te(h)), b = l(() => {
    const e = m.value.filter((n) => n.filterOptionValues !== void 0 || n.filterOptionValue !== void 0), t = {};
    return e.forEach((n) => {
      var r;
      n.type === "selection" || n.type === "expand" || (n.filterOptionValues === void 0 ? t[n.key] = (r = n.filterOptionValue) !== null && r !== void 0 ? r : null : t[n.key] = n.filterOptionValues);
    }), Object.assign(N(u.value), t);
  }), p = l(() => {
    const e = b.value, {
      columns: t
    } = a;
    function i(f) {
      return (c, s) => !!~String(s[f]).indexOf(String(c));
    }
    const {
      value: {
        treeNodes: n
      }
    } = P, r = [];
    return t.forEach((f) => {
      f.type === "selection" || f.type === "expand" || "children" in f || r.push([f.key, f]);
    }), n ? n.filter((f) => {
      const {
        rawNode: c
      } = f;
      for (const [s, g] of r) {
        let d = e[s];
        if (d == null || (Array.isArray(d) || (d = [d]), !d.length))
          continue;
        const y = g.filter === "default" ? i(s) : g.filter;
        if (g && typeof y == "function")
          if (g.filterMode === "and") {
            if (d.some((R) => !y(R, c)))
              return !1;
          } else {
            if (d.some((R) => y(R, c)))
              continue;
            return !1;
          }
      }
      return !0;
    }) : [];
  }), {
    sortedDataRef: _,
    deriveNextSorter: I,
    mergedSortStateRef: T,
    sort: A,
    clearSorter: W
  } = ne(a, {
    dataRelatedColsRef: m,
    filteredDataRef: p
  });
  m.value.forEach((e) => {
    var t;
    if (e.filter) {
      const i = e.defaultFilterOptionValues;
      e.filterMultiple ? u.value[e.key] = i || [] : i !== void 0 ? u.value[e.key] = i === null ? [] : i : u.value[e.key] = (t = e.defaultFilterOptionValue) !== null && t !== void 0 ? t : null;
    }
  });
  const q = l(() => {
    const {
      pagination: e
    } = a;
    if (e !== !1)
      return e.page;
  }), B = l(() => {
    const {
      pagination: e
    } = a;
    if (e !== !1)
      return e.pageSize;
  }), G = j(q, O), S = j(B, z), U = k(() => {
    const e = G.value;
    return a.remote ? e : Math.max(1, Math.min(Math.ceil(p.value.length / S.value), e));
  }), H = l(() => {
    const {
      pagination: e
    } = a;
    if (e) {
      const {
        pageCount: t
      } = e;
      if (t !== void 0)
        return t;
    }
  }), M = l(() => {
    if (a.remote)
      return P.value.treeNodes;
    if (!a.pagination)
      return _.value;
    const e = S.value, t = (U.value - 1) * e;
    return _.value.slice(t, t + e);
  }), J = l(() => M.value.map((e) => e.rawNode));
  function L(e) {
    const {
      pagination: t
    } = a;
    if (t) {
      const {
        onChange: i,
        "onUpdate:page": n,
        onUpdatePage: r
      } = t;
      i && o(i, e), r && o(r, e), n && o(n, e), C(e);
    }
  }
  function Q(e) {
    const {
      pagination: t
    } = a;
    if (t) {
      const {
        onPageSizeChange: i,
        "onUpdate:pageSize": n,
        onUpdatePageSize: r
      } = t;
      i && o(i, e), r && o(r, e), n && o(n, e), x(e);
    }
  }
  const V = l(() => {
    if (a.remote) {
      const {
        pagination: e
      } = a;
      if (e) {
        const {
          itemCount: t
        } = e;
        if (t !== void 0)
          return t;
      }
      return;
    }
    return p.value.length;
  }), X = l(() => Object.assign(Object.assign({}, a.pagination), {
    // reset deprecated methods
    onChange: void 0,
    onUpdatePage: void 0,
    onUpdatePageSize: void 0,
    onPageSizeChange: void 0,
    "onUpdate:page": L,
    "onUpdate:pageSize": Q,
    // writing merged props after pagination to avoid
    // pagination[key] === undefined
    // key still exists but value is undefined
    page: U.value,
    pageSize: S.value,
    pageCount: V.value === void 0 ? H.value : void 0,
    itemCount: V.value
  }));
  function C(e) {
    const {
      "onUpdate:page": t,
      onPageChange: i,
      onUpdatePage: n
    } = a;
    n && o(n, e), t && o(t, e), i && o(i, e), O.value = e;
  }
  function x(e) {
    const {
      "onUpdate:pageSize": t,
      onPageSizeChange: i,
      onUpdatePageSize: n
    } = a;
    i && o(i, e), n && o(n, e), t && o(t, e), z.value = e;
  }
  function Y(e, t) {
    const {
      onUpdateFilters: i,
      "onUpdate:filters": n,
      onFiltersChange: r
    } = a;
    i && o(i, e, t), n && o(n, e, t), r && o(r, e, t), u.value = e;
  }
  function Z(e, t, i, n) {
    var r;
    (r = a.onUnstableColumnResize) === null || r === void 0 || r.call(a, e, t, i, n);
  }
  function $(e) {
    C(e);
  }
  function ee() {
    D();
  }
  function D() {
    w({});
  }
  function w(e) {
    E(e);
  }
  function E(e) {
    e ? e ? u.value = N(e) : process.env.NODE_ENV !== "production" && ae("data-table", "`filters` is not an object") : u.value = {};
  }
  return {
    treeMateRef: P,
    mergedCurrentPageRef: U,
    mergedPaginationRef: X,
    paginatedDataRef: M,
    rawPaginatedDataRef: J,
    mergedFilterStateRef: b,
    mergedSortStateRef: T,
    hoverKeyRef: v(null),
    selectionColumnRef: F,
    childTriggerColIndexRef: K,
    doUpdateFilters: Y,
    deriveNextSorter: I,
    doUpdatePageSize: x,
    doUpdatePage: C,
    onUnstableColumnResize: Z,
    // exported methods
    filter: E,
    filters: w,
    clearFilter: ee,
    clearFilters: D,
    clearSorter: W,
    page: $,
    sort: A
  };
}
export {
  Pe as useTableData
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/use-table-data.js
// module id = 1621
// module chunks = 41